
import React, { useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";
import { useLocation } from 'react-router-dom';

import styles from "./SwappingStation.module.scss";
import Master from "screen/Master";
import EnergyComponent from "./EnergyComponent";
import EnergyComponentSwap from "./EnergyComponentSwap";
import EnergyComponentsLine from "./EnergyComponentsLineSwapStation";
import TableAndSearch from "components/common/TableAndSearch";
import Button from "@material-ui/core/Button";
import Swapping from "../echarts/Swapping";
import { getRequest, postRequest } from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import styled from "styled-components";
import LocalStorageService from "services/tokenlocalstorage.service";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";
import SlotDetails from "components/swappingStations/SlotDetails";
import { SystemUpdate } from "@material-ui/icons";
const Styles = styled.div`
  table {
    th,
    td {
      white-space: wrap;
    }
  }
  .double-screen-pagination {
    margin-top: 40px !important;
    height: 50px;
    padding: 0;
    right: 18px !important;
  }
`;
var id = undefined;
var siteId = undefined;

let multiselectArray = [];
function SwapingStation(props) {
  id = props?.match?.params?.id;
  if (id && id != null) {
    const ids = id.split("-");
    id = ids[0];
    siteId = ids[1];
  } else {
    id = undefined;
    siteId = undefined;
  }

  const filterInitialValue = {
    siteId: props.siteId ? props.siteId : siteId ? siteId : "",
    chargerId: id ? id : "",
    state: "",
    stateId: "",
    city: "",
    cityId: "",
    zoneId: "",
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    time: "HOUR_24",
    swapStationId: null,
  };

  let multiselectArray = [];
  var offset = 0;
  var pageLimit = 10;

  const location = useLocation();
  const [filter, setFilter] = useState(filterInitialValue);
  const [selectTime, setSelectTime] = useState("HOUR_24");
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [swappingData, setSwappingData] = useState([]);
  const [filterData, setChargerMultiSelecct] = useState(multiselectArray);
  const [swapStationList, setswapStationList] = useState([]);
  const [swapStationSiteBaseList, setSwapStationSiteBaseList] = useState([]);
  const [swappedEnergyData, setSwappedEnergyData] = useState([]);
  const [tab, setTab] = useState(1);
  const [timePeriod, setTimePeriod] = useState("");
  const [time, setTime] = useState("HOUR_24");
  // <<<<<<< HEAD
  // const [swappedSessionGraphData, setSwappedSessionGraphData] = useState([]);
  const [swappingListCount, setSwappingListCount] = useState(0);

  const [faultGraphData, setFaultGraphData] = useState([]);
  // const [data, setData] = useState('');
  // swapStation/swapStationFaultGraph
  // =======
  const [swappedSessionData, setSwappedSessionData] = useState([]);
  const [data, setData] = useState("");
  const [swappedSessionGraphData, setSwappedSessionGraphData] = useState([]);
  const [swapStationCount, setSwapStationCount] = useState("");
  const [totalSwapStationCount, setTotalSwapStationCount] = useState("");

  useEffect(() => {
    localStorage.setItem("activeTabCount", "other");
    setTimePeriod(location?.state);
  },[])

  useEffect(() => {
    // getSwapStationList("timeFilterEnum=HOUR_24");
    getSwappedEnergyData(filter.startDate, filter.endDate, filter);
    // getSwappedSessionData(filter.startDate, filter.endDate, filter);
    getSwappedSessionGraphData(filter.startDate, filter.endDate, filter);
    getSwappedFaultData(filter.startDate, filter.endDate, filter);
    getSWappingCountHeader(filter)
    // pageLimitHandle();
    //searchSwapStationByFilter();
    return
    // /assets/bss/swappingStation/getswapStationInfo?siteId=1
  }, [props.headerFilter]);

  // useEffect(() => {
    // getSwapStationList("timeFilterEnum=HOUR_24");
    // getSwappedEnergyData(filter.startDate, filter.endDate, filter);
    // getSwappedSessionData(filter.startDate, filter.endDate, filter);
    // getSwappedSessionGraphData(filter.startDate, filter.endDate, filter);
    // getSwappedFaultData(filter.startDate, filter.endDate, filter);
    // pageLimitHandle();
    // searchSwapStationHeader();
    // return
    // /assets/bss/swappingStation/getswapStationInfo?siteId=1
  // }, [props.headerFilter]);

  const swapStaionIdHandle = useCallback(async () => {
    await getRequestInAssets(
      `bss/swappingStation/getswapStationInfo?siteId=${filter.siteId}`
    ).then((res) => {
      if (res && res?.data) {
        setSwapStationSiteBaseList(res.data?.swapStationList);
      }
    });
  });

  const getSwappedSessionGraphData = useCallback(
    async (startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined || filter?.chargerId === ""
          ? ""
          : "&swapStationId=" + filter.chargerId) +
        (filter?.time === undefined || filter?.time === ""
          ? ""
          : "&timeFilterEnum=" + filter.time) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);

      await getRequest(`swapping/reserveSwaps?` + query)
        .then((res) => {
          if (res && res?.data) {
            setSwappedSessionGraphData(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );

  const getSwappedFaultData = useCallback(
    async (startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined ||
        filter?.chargerId === "" ||
        filter?.chargerId === null
          ? ""
          : "&swapStationId=" + filter.chargerId) +
        (filter?.time === undefined || filter?.time === ""
          ? ""
          : "&timeFilterEnum=" + filter.time) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);

      var url = "swapStationFaultGraph";
      // if (id && id != null) {
      //   url = "swapStationFaultGraph";
      // }

      await getRequest(`swapStation/${url}?` + query)
        .then((res) => {
          if (res && res?.data) {
            setFaultGraphData(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );

  const getSwappedEnergyData = useCallback(
    async (startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var obj = {
        timeFilterEnum: filter?.time ? filter.time : null,
      }
      
        if(headerFilterObj?.cityId ){
          obj = {...obj, cityId: headerFilterObj.cityId}
        }
        if(headerFilterObj?.siteId ){
          obj = {...obj, siteId: headerFilterObj.siteId}
        }
        if(headerFilterObj?.stateId ){
          obj = {...obj, stateId: headerFilterObj.stateId}
        }
        if(headerFilterObj?.zoneId ){
          obj = {...obj, zoneId: headerFilterObj.zoneId}
        }
        if(headerFilterObj?.swapStationId ){
          obj = {...obj, swapStationId: headerFilterObj.swapStationId}
        }
     
        if(filter?.siteId === undefined || filter?.siteId != "")
        obj = {...obj, siteId: filter.siteId}
        if(filter?.chargerId != undefined || filter?.chargerId != "" || filter?.chargerId != null)
        obj = {...obj, swapStationId: filter.chargerId}
        if(filter?.siteId === undefined || filter?.siteId != "")
        obj = {...obj, siteId: filter.siteId}
       

      await postRequest(`bss/getSwappingCount` 
      , obj
      )
        .then((res) => {
          if (res && res?.data) {
            setSwappedEnergyData(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );
  const pageLimitHandle = (string, limit) => {
    getSwappedSessionData(
      filter.startDate,
      filter.endDate,
      filter,
      string,
      limit
    );
  };


  const getSWappingCountHeader = useCallback( async (filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId)+
          (filter?.chargerId === undefined ||
            filter?.chargerId === "" ||
            filter?.chargerId === null
              ? ""
              : "&swapStationId=" + filter.chargerId);

      await getRequest(
        `swapping/swappingInfo?` +
          query 
      )
        .then((res) => {
          if (res && res?.data) {
            // setSwappedSessionData(res?.data?.list);
            setTotalSwapStationCount(res.data.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );



  const getSwappedSessionData = useCallback(
    async (startDate, endDate, filter, c, limit) => {
      // return;
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      if (c === "front") {
        offset = offset + 10;
      } else {
        if (offset > 0) {
          offset = offset - 10;
        }
      }

      var query =
        // (filter?.startDate
        //   ? "startDate=" + filter.startDate
        //   : startDate
        //   ? "startDate=" + startDate
        //   : "") +
        // (filter?.endDate
        //   ? "&endDate=" + filter?.endDate
        //   : endDate
        //   ? "&endDate=" + endDate
        //   : "") +
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined || filter?.chargerId === ""
          ? ""
          : "&swapStationId=" + filter.chargerId) +
        (time === undefined || time === ""
          ? ""
          : "&timeFilterEnum=" + time) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);

      await getRequest(
        `swapping/swappingInfo?` +
          query +
          `&limit=${limit ? limit : pageLimit}&offset=${
            offset > 0 ? offset : 0
          } `
      )
        .then((res) => {
          if (res && res?.data) {
            setSwappedSessionData(res?.data?.list);
            setSwapStationCount(res.data.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          // alert("You clicked outside of me!");
        } else {
          setOpen(true);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [open, setOpen] = React.useState(false);

  const handleClick = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        setFilter(filterInitialValue);
        filter.siteId = filterInitialValue.siteId;
        filter.chargerId = filterInitialValue.chargerId;
        filter.time = filterInitialValue.time;
        setSelectTimeValue(filterInitialValue.time);

        getSwappedEnergyData(
          filterInitialValue.startDate,
          filterInitialValue.endDate,
          filterInitialValue
        );
        getSwappedSessionGraphData(
          filterInitialValue.startDate,
          filterInitialValue.endDate,
          filterInitialValue
        );
        getSwappedFaultData(
          filterInitialValue.startDate,
          filterInitialValue.endDate,
          filterInitialValue
        );
          setChargerList([]);

        //getSwappingData(
        //   filterInitialValue.startDate,
        //   filterInitialValue.endDate,
        //   filterInitialValue
        // );
      } else {
        if (filter.siteId) {
          swapStaionIdHandle();
        }

        getSwappedEnergyData(filter.startDate, filter.endDate, filter);

        getSwappedSessionGraphData(filter.startDate, filter.endDate, filter);
        getSwappedFaultData(filter.startDate, filter.endDate, filter);

        // getSwappedSessionData(filter.startDate, filter.endDate, filter);

        setSelectTimeValue(selectTime);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const getSites = useCallback(async () => {
    await getRequestInAssets("bss/site/siteList")
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
          if (siteId) {
            setFilter({ ...filter, siteId: siteId });
            getChargers(siteId);
          }
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const getSwappingData = useCallback(async (startDate, endDate, filter) => {
    let callString = `swapping/getSiteStatus?timeFilterEnum=` + filter.time;
    if (filter.cityId > 0) {
      callString += "&cityId=" + filter.cityId;
    }
    if (filter.stateId > 0) {
      callString += "&stateId=" + filter.stateId;
    }
    if (filter.zoneId > 0) {
      callString += "&zoneId=" + filter.zoneId;
    }
    if (filter.siteId > 0) {
      callString += "&siteId=" + filter.siteId;
    }
    await getRequestInAssets(callString)
      .then((res) => {
        if (res && res?.data) {
          setSwappingData(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  useEffect(() => {
    getSites();
    //getSwappingData(filter.startDate, filter.endDate, filter);
  }, []);

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
          if (id) {
            setFilter({ ...filter, chargerId: id });
          }
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2628000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7884000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      getChargers(event.target.value);
    }
  };

  // const [open, setOpen] = React.useState(false);
  const [droppedFilter, setDroppedFilter] = useState(false);

  // const searchBySwapStationID = (searchString) => {
  //   if (searchString === undefined || searchString === "") {
  //     // getSwapStationList("timeFilterEnum=HOUR_24");
  //     getSwappedSessionData(filter.startDate, filter.endDate, filter);
  //   } else {
  //     getRequest(`swapping/swappingInfo?filter=${searchString}&offset=0`)

  //       .then((res) => {
  //         if (res && res?.data) {
  //           setSwappedSessionData(res?.data?.list);
  //           setSwapStationCount(res.data.count);
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error", err);
  //       });
  //   }
  // };

  const searchSwapStationByFilter = (filter, searchString) => {
    if (filter === undefined || filter === "") {
      getSwappedSessionData(filter.startDate, filter.endDate, filter);
    } else {
      setData(searchString);
      getRequest(`swapping/swappingInfo?${filter}`)
        .then((res) => {
          if (res && res?.data) {
            setSwappedSessionData(res?.data.list);
            setSwapStationCount(res?.data?.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    }
  };

  const columns = React.useMemo(() => [
    {
      Header: "Driver Name",
      accessor: "driverName",
    },
    {
      Header: "Vehicle",
      accessor: "vehicle",
    },
    {
      Header: "Swap Station Name",
      accessor: "swapStationName",
    },
    {
      Header: "Charged Battery SOC(%)",
      accessor: "chargedSOC",
    },
    {
      Header: "Swapped Battery SOC(%)",
      accessor: "avaliableSOC",
      // accessor: "chargedSOC",
    },
    // {
    //   Header: "Swapped Battery SOC",
    //   accessor: "swappedBatterySOC",
    // },
    {
      Header: "Energy Dispatch(kWh)",
      accessor: "energyDispatch",
      Cell: (row) => {
        return  <div style={{ paddingLeft:"10px"}}>{row.row?.original?.energyDispatch? Number(row.row?.original?.energyDispatch).toFixed(2) : 0}</div>;
      },
    },
    {
      Header: "Revenue (₹)",
      accessor: "revenue",
    },
    {
      Header: "Swap Time",
      accessor: "swapDateTime",
    },
    {
      Header: "Battery In",
      accessor: "inBatterySerial",
    },
    {
      Header: "Slot in",
      accessor: "inSlot",
    },
    {
      Header: "Battery Out",
      accessor: "outBatterySerial",
    },
    {
      Header: "Slot Out",
      accessor: "outSlot",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Cause of Failure",
      accessor: "reasonOfFailure",
    },
  ]);

  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Swapping"}
      </h2>

      <div className={cn(styles.block8, styles.block8_layout)}>
        <div className={cn(styles.block8_item)}>
          <div className={cn(styles.block23, styles.block23_layout)}>
            <div className={cn(styles.box10, styles.box10_layout)} />
            <div className={cn(styles.box11, styles.box11_layout)}>
              <>
                <img
                  src={require("assets/total_batteries_icon.png").default}
                  style={{
                    marginLeft: "7px",
                    marginTop: "6px",
                    cursor: "pointer",
                  }}
                />
              </>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer)} />
        <div className={cn(styles.block8_item1)}>
          <div
            className={cn(
              styles.swapping_header_count_container,
              styles.block21_layout
            )}
          >
            <div className={cn(styles.block22, styles.block22_layout)}>
              <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {"Total Count"}
              </h3>
            </div>

            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout
              )}
            >
              {totalSwapStationCount}
            </div>
            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout1
              )}
            >
              {""}
            </div>
          </div>
        </div>
      </div>

      <div
        ref={wrapperRef}
        className={cn(styles.block1, styles.block1_layout)}
        style={{ cursor: "pointer" }}
        onClick={() => setDroppedFilter(!droppedFilter)}
      >
        <div className={cn(styles.block2, styles.block2_layout)}>
          <div className={cn(styles.block2_item)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div
                style={{
                  "--src": `url(${require("assets/filterblack.png").default})`,
                }}
                className={cn(styles.image1, styles.image1_layout)}
              />
            </div>
          </div>

          <div className={cn(styles.block2_spacer)} />

          <div className={cn(styles.text_body, styles.text_body_layout)}>
            {"Filters"}
          </div>
          {open && (
            <div id="filter" open={open}>
              <div
                style={{ cursor: "pointer" }}
                className={cn(
                  styles.status1_block,
                  styles.status1_block_layout
                )}
              >
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="time"
                    id="time"
                    onChange={handleChange}
                    value={filter.time}
                  >
                    <option value="-1" disabled>
                      Select Time Period
                    </option>
                    <option value="HOUR_24">Last 24 hours</option>
                    <option value="HOUR_12">Last 12 hours</option>
                    <option value="WEEK">Last 1 week</option>
                    <option value="WEEK_2">Last 2 weeks</option>
                    <option value="MONTH">Last 1 month</option>
                    <option value="MONTH_3">Last 3 months</option>
                  </select>
                </div>
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="siteId"
                    id="siteId"
                    onChange={handleChange}
                    value={filter.siteId}
                    disabled={siteId}
                  >
                    <option value="-1" selected>
                      Select Site
                    </option>
                    {sitesList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="chargerId"
                    id="chargerId"
                    onChange={handleChange}
                    value={filter.chargerId}
                    disabled={id}
                  >
                    <option value="" disabled selected>
                      Select Swap Station
                    </option>
                    {chargerList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div>
                  <Button
                    style={{
                      background: "#E3324C",
                      color: "white",
                      margin: "15px 0px 6px 35px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("reset");
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    style={{
                      background: "#23297A",
                      color: "white",
                      margin: "15px 0px 6px 20px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("apply");
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={cn(styles.flex4, styles.flex4_layout)}>
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                {/* <pre className={cn(styles.highlights)}> */}
                {"Recent"}
                <EnergyComponent
                  data={swappedEnergyData}
                  selectTimeValue={selectTimeValue}
                />
                {/* </pre> */}
              </h5>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                {/* <pre className={cn(styles.highlights)}> */}
                {"Reserved"}
                <EnergyComponentSwap
                  swappedSessionGraphData={swappedSessionGraphData}
                  selectTimeValue={selectTimeValue}
                  //selectTimeValue={"MONTH"}
                />
                {/* </pre> */}
              </h5>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                {/* <pre */}
                {/* className={cn(styles.highlights)} */}
                {/* // style={{ width: "auto", minWidth: "150px" }} */}
                {/* > */}
                {"Fault"}
               
                 <EnergyComponentsLine
                    data={faultGraphData}
                    selectValue={selectTimeValue}
                  />
                {/* </pre> */}
              </h5>
            </div>
          </div>
        </div>
      </div>

      <hr className={cn(styles.line, styles.line_layout)} />
      {id ? (
        <div className={cn(styles.flex3, styles.flex3_layout)}>
          {/* tab, setTab */}

          <h3
            style={{ cursor: tab == 1 ? "text" : "pointer" }}
            className={
              tab === 1
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle1, styles.subtitle1_layout)
            }
            onClick={() => {
              setTab(1);
            }}
          >
            {"Swapping Details"}
          </h3>
          <div className={cn(styles.flex3_spacer)} />
          <h3
            style={{ cursor: tab == 1 ? "pointer" : "text" }}
            className={
              tab === 2
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle1, styles.subtitle1_layout)
            }
            onClick={() => {
              setTab(2);
            }}
          >
            {"Slot Details"}
          </h3>
          <div className={cn(styles.flex3_spacer1)} />

          <div className={cn(styles.flex3_spacer1)} />
        </div>
      ) : (
        <div></div>
      )}

      {tab === 1 || !id ? (
        <Styles>
          <NewTableAndSearchMasterFilter
            searchOpts={{
              // onSearch: searchBySwapStationID,
              placeholder: "Search by Swap Station Name",
              filter: true,
              onFilterSearch: searchSwapStationByFilter,
              screentype: "swapping",
              disableFilter: { siteId: siteId, chargerId: id },
            }}
            headerFilter={props.headerFilter}
            setTime={setTime}
            columns={columns}
            paginationDoubleScreen={true}
            // timeInfo = {location?.state?.test}
            data={swappedSessionData}
            swapStationCount={swapStationCount}
          />
        </Styles>
      ) : (
        <SlotDetails id={id} />
      )}
    </>
  );
}

export default function SwappingStationView(props) {
  const swappingId = props.match.params.id;
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master
        swapping={Urls}
        opts={props}
        screen={SwapingStation}
        showStatus={true}
        swappingId={swappingId}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

SwappingStationView.inStorybook = true;
